module.exports = __webpack_public_path__ + "static/media/hp-group-desktop.325d936d.svg";